import { Box, Button } from '@mui/material';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

type ExpandCollapseButtonProps = {
  isExpanded: boolean;
  onToggle: () => void;
  collapsedLabel?: string;
  expandedLabel?: string;
};

const iconStyle = (isExpanded: boolean) => ({
  fontSize: '14px',
  transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.3s ease',
});

const ExpandCollapseButton = ({
  isExpanded,
  onToggle,
  collapsedLabel = 'Show full document',
  expandedLabel = 'Hide',
}: ExpandCollapseButtonProps) => (
  <Box textAlign="center">
    <Button onClick={onToggle} variant="text" size="small">
      <KeyboardDoubleArrowDownIcon sx={{ mr: 1, ...iconStyle(isExpanded) }} />
      {isExpanded ? expandedLabel : collapsedLabel}
      <KeyboardDoubleArrowDownIcon sx={{ ml: 1, ...iconStyle(isExpanded) }} />
    </Button>
  </Box>
);

export default ExpandCollapseButton;
